import React, {useState, useEffect} from 'react'
import { Tooltip } from "@mui/material"

export default ({ children, title }) => {
    const [tooltipOpen, setTooltipOpen] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            if (tooltipOpen) {
                setTooltipOpen(false)
            }
        }
        window.addEventListener("scroll", handleScroll, true)
        return () => window.removeEventListener("scroll", handleScroll, true)
    }, [tooltipOpen])

    return (
        <Tooltip
            open={tooltipOpen}
            onOpen={() => setTooltipOpen(true)}
            onClose={() => setTooltipOpen(false)}
            title={title}
            arrow
            slotProps={{
                transition: { timeout: 0 },
                tooltip: {
                    sx: {
                        border: "1px solid var(--border-primary)",
                        backgroundColor: "var(--background-primary)",
                        color: "var(--text-primary)",
                        fontSize: "14px",
                        "& .MuiTooltip-arrow": {
                            color: "var(--background-primary)",
                        },
                    },
                },
            }}
        >
            <div style={{ display: "flex", alignItems: "center" }}
                onMouseEnter={() => setTooltipOpen(true)}
                onMouseLeave={() => setTooltipOpen(false)}
            >
                {children}
            </div>
        </Tooltip>
    )
}